import * as runtime from '../../runtime';
import { IInitializeServiceOptions } from '../../types';
import { ConfigInfo, IGetOrgExpandedAttributesByOrgIdRequest, OrgExpandedAttributes, UserProfile } from './models';

export class IICsIdentityService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}

	async getConfigInfoRaw(): Promise<runtime.ApiResponse<ConfigInfo>> {
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: '/configInfo',
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}
	async getConfigInfo(): Promise<ConfigInfo> {
		const response = await this.getConfigInfoRaw();
		return response.value();
	}

	async getUserProfileRaw(): Promise<runtime.ApiResponse<UserProfile>> {
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: '/api/v1/UserProfile',
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}

	async getUserProfile(): Promise<UserProfile> {
		const repsonse = await this.getUserProfileRaw();
		return repsonse.value();
	}
	async getOrgExpandedAttributesByOrgIdRaw(
		requestParameters: IGetOrgExpandedAttributesByOrgIdRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<OrgExpandedAttributes>> {
		if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
			throw new runtime.RequiredError(
				'orgId',
				'Required parameter requestParameters.orgId was null or undefined when calling getOrgExpandedAttributesByOrgId.',
			);
		}
		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request({
			path: `/api/v1/Orgs('${requestParameters.orgId}')?$expand=attributes`,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		});

		return new runtime.JSONApiResponse(response);
	}

	async getOrgExpandedAttributesByOrgId(
		requestParameters: IGetOrgExpandedAttributesByOrgIdRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<OrgExpandedAttributes> {
		const repsonse = await this.getOrgExpandedAttributesByOrgIdRaw(requestParameters, initOverrides);
		return repsonse.value();
	}
}
export const initializeIdentityService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const identityService = new IICsIdentityService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs.identity,
		}),
		tenantId,
	);

	return identityService;
};
